import * as React from "react";

/**
 * Internal dependencies.
 */
import ArrowIcon from '§/src/images/svg/arrow-r.svg';
import './_button-arrow.scss';


const ButtonArrow = ( props ) => {

  // set atom class
  const btnClass = props.btn || 'btn-link'; // default button class
  const atomClassName = 'button-arrow btn ' + btnClass;
  const atomClass = props.className !== undefined ? atomClassName + ' ' + props.className : atomClassName;

  const text = props.text !== undefined ? props.text : null;

  // Estrarre le prop standard per il button e scartare le prop personalizzate
  const { btn, className, text: textProp, ...buttonProps } = props;

  return (
    <button { ...buttonProps }  className={ atomClass }>
      <i className="rounded-pill"><ArrowIcon/></i>
      {
      text ?
        <span>{text}</span>
      : null
      }
    </button>
  )
}

export default ButtonArrow
